<template>
  <svg :width="size" :height="size" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m13.886 16 7.057-7.057a1.333 1.333 0 1 0-1.886-1.886l-8 8c-.52.52-.52 1.365 0 1.886l8 8a1.333 1.333 0 1 0 1.886-1.886L13.886 16z"
      :fill="color"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class IconChevronLeft extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
}
export default IconChevronLeft;
</script>
